import {IApartmentDto} from "../../dtos/apartments/IApartmentDto";
import {IHotelDto} from "../../dtos/hotels/IHotelDto";
import {createSlice} from "@reduxjs/toolkit";
import {RootState} from "../store";
import {AppDependencies} from "../../services/appDependencies";

interface MainState {
    selectedApartments: IApartmentDto[];
    selectedHotel?: IHotelDto;
    activePageTitle: string;
}

const initialState: MainState = {
    selectedApartments: [],
    activePageTitle: ""
}

export const mainSlice = createSlice({
    name: "main",
    initialState,
    reducers: {
        setSelectedHotel: (state, action) => {
            state.selectedHotel = action.payload.hotel;
            AppDependencies.Axios.defaults.headers.common['hotelId'] = action.payload.hotel?.id;
        },
        setSelectedApartments: (state, action) => {
            state.selectedApartments = action.payload.apartments;
        },
        setActivePageTitle: (state, action) => {
            state.activePageTitle = action.payload.title;
        }
    }
});

export const {setActivePageTitle, setSelectedHotel, setSelectedApartments} = mainSlice.actions;
export const getSelectedHotel = (state: RootState) => state.main.selectedHotel;
export const getSelectedApartments = (state: RootState) => state.main.selectedApartments;
export const getActivePageTitle = (state: RootState) => state.main.activePageTitle;
export const main = mainSlice.reducer;